module.exports = __webpack_public_path__ + "img/2018.d36b54c7.svg";